export default __webpack_public_path__ + "resources/icons/n500-e03d.png";